<router-view />
<!-- This will render the current route's component -->